import { HttpRequestMethod, send } from "./utils/send";

export const sendPostUserAgreementSignature = (): Promise<number> =>
  send<number>("/user-agreement-signatures", HttpRequestMethod.POST);
